module.exports = __webpack_public_path__ + "img/home-cat.9d693f63.png";